import { BlogPost } from "@/db/blogPostsData";
import Image from "next/image";
import Link from "next/link";

const BlogCard = ({ post }: { post: BlogPost }) => {
   

  return (
    <div className="single-blog-post mb-25">
      {/* ✅ Image links with pathname + query */}
      <Link
        href={{
          pathname: "/eventsDetails",
          query: { id: post.id }, // 👈 use key:value (not just post.id)
        }}
        className="image d-block"
      >
        <Image
          width={416}
          height={364}
          sizes="100vw"
          src={post.image}
          alt={post.title || "Blog image"}
        />
      </Link>

      <div className="content">
        <div className="info position-relative">
          <ul className="d-flex align-items-center p-0 mb-0 list-unstyled">
            <li className="d-inline-block position-relative">
              {post.date} <br />
              {post.month}
            </li>
            <li className="d-inline-block position-relative">
              <i className="fa-regular fa-circle-user" /> {" "}
              <Link 
               href={{
          pathname: "/eventsDetails",
          query: { id: post.id }, // 👈 use key:value (not just post.id)
        }}
              >{post.author}</Link>
            </li>
          </ul>
        </div>

        {/* ✅ Title link using object-based href */}
        <h3 className="fw-semibold fs-5">
          <Link
            href={{
              pathname: "/eventsDetails",
              query: { id: post.id },
            }}
          >
            {post.title}
          </Link>
        </h3>

        {/* ✅ Continue Reading button with same dynamic query */}
        <div className="text-end">
          <Link
            href={{
              pathname: "/eventsDetails",
              query: { id: post.id },
            }}
            className="default-btn"
          >
            Continue Reading
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
